import { tv } from '~/utils/tv'

export const optionMenuItemContainerVariants = tv({
  base: 'flex items-center space-x-2',
  variants: {
    type: {
      single: 'px-twopulse py-onepulse',
      multi: 'px-twopulse py-onepulse',
    },
  },
})

export const optionMenuItemWrapperVariants = tv({
  base: 'gap-onepulse p-onepulse',
})

export const optionMenuItemButtonVariants = tv({
  base: [
    'bg-action-fill-neutral-tertiary-enabled',
    'border-border-neutral-tertiary-enabled',
    'border-none',
    'duration-100 ease-in',

    'focus:border-x-halfpulse',
    'focus:border-y-halfpulse',
    'focus:border-action-border-focused',
    'focus:rounded-pill',

    'hover:bg-action-fill-neutral-tertiary-hovered',
    'hover:border-action-border-neutral-tertiary-hovered',
    'hover:rounded-pill',

    'disabled:cursor-not-allowed',
    'disabled:bg-action-fill-neutral-tertiary-disabled',
    'disabled:border-action-border-neutral-tertiary-disabled',
    'disabled:border-none',

    'active:bg-action-fill-neutral-tertiary-pressed',
    'active:border-action-border-neutral-tertiary-pressed',
    'active:rounded-pill',

    'px-twopulse',
    'py-onepulse',
  ],
})
